import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLayoutSpalte.vue?vue&type=template&id=50e9138f&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLayoutSpalte.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLayoutSpalte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9138f",
  null
  
)

export default component.exports